module.exports = __webpack_public_path__ + "img/bingo_ball-80.5c179d23.png";